import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

/**
 * Documentos personales del usuario (INE, constancia fiscal, carátula
 * bancaria) y su RFC.
 *
 * Se guardan con los mismos nombres de campo y la misma ruta de Storage que la
 * app (`recnet-24/app/screens/Documents/index.js`), para que un documento
 * subido desde la web se vea en la app y viceversa.
 */

/** Documentos que se suben como archivo; `campo` es la clave en `app_usuarios`. */
export const DOCUMENTOS = [
  { tipo: "INE", campo: "ine", label: "INE" },
  { tipo: "cedula", campo: "cedula", label: "Constancia de situación fiscal" },
  { tipo: "estado_cuenta", campo: "estado_cuenta", label: "Carátula bancaria" },
];

/**
 * Sube un archivo a Storage en la ruta que usa la app
 * (`documentos/{email}/{tipo}/{archivo}`) y guarda su URL en `app_usuarios`.
 */
export async function subirDocumento({ email, id, tipo, campo, archivo }) {
  const ref = firebase.storage().ref(`documentos/${email}/${tipo}/${archivo.name}`);
  const resultado = await ref.put(archivo);
  const url = await resultado.ref.getDownloadURL();

  await firebase.firestore().collection("app_usuarios").doc(id).update({ [campo]: url });
  return url;
}

/** Guarda el RFC (texto) en el documento del usuario. */
export function guardarRfc(id, rfc) {
  return firebase.firestore().collection("app_usuarios").doc(id).update({ rfc: String(rfc || "").trim() });
}
